import React, {Component} from 'react';
import {FormattedDate, FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import get from 'get-value';
import PropTypes from 'prop-types';
import 'react-picky/dist/picky.css';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import {clearAlerts} from '../../../actions/alertsActions';
import formStatesMessages from '../../../intl/common/formStatesMessages';
import {
    domains,
    getDealerFormTypes,
    getEditorFormTypes, immobilizedVehicle,
    internalStatuses,
    problemTypes,
    srcRequestType
} from '../../../constants/Utils';
import formTypeMessages from '../../../intl/common/formTypeMessages';
import HistoryDocTable from './HistoryTechDocTable';
import DatePickerTableComponent from '../../common/datePicker/DatePickerTableComponent';
import commonMessages from '../../../intl/common/commonMessages';
import historyMessages from '../../../intl/technicalDocumentations/historyMessages';
import {
    updateTechDocUserHistoryPreference
} from '../../../actions/techDoc/actionTechDocPreferences';
import Loader from '../../Loader';
import PageHeader from '../../common/PageHeader';
import {StyledPicky} from '../../common/StyledComponents';
import {moduleRoles} from '../../../utils/roles';
import internalStatusMessages from '../../../intl/technicalDocumentations/internalStatusMessages';
import problemTypeMessages from '../../../intl/technicalDocumentations/problemTypeMessages';
import checkRoles from '../../common/roleChecker/RoleChecker';
import {fillNumberFiveZero} from '../../../utils/utils';
import immobilizedVehicleMessages from '../../../intl/technicalDocumentations/immobilizedVehicleMessages';
import clientTypeMessages from '../../../intl/technicalDocumentations/clientTypeMessages';

const domain = domains.TECHNICAL_DOCUMENTATION;

class HistoryTechDocPage extends Component {
    constructor(props) {
        super(props);
        const {intl, loggedUser, loggedUser: {roles}} = props;

        let isEditor = false;
        let isDealer = false;

        if (moduleRoles.isEditorDocumentation(roles)) isEditor = true;
        if (!isEditor && moduleRoles.isDealerDocumentation(roles)) isDealer = true;

        const managedGroups = get(props, `loggedUser.roles.${domain}.dealer`) ? [get(props, 'loggedUser.group', 'XX')] : moduleRoles.getEditorGroups(domain, get(props, 'loggedUser.roles', {})).map(({group}) => group);
        this.state = {
            ratchet: true,
            columnLibrary: [
                {
                    id: 'VOR_RELATED',
                    accessor: 'pviRelated',
                    message: historyMessages.TABLE_VOR_RELATED,
                    Filter: ({filter, onChange}) => (
                        <select onChange={event => onChange(event.target.value)}
                                style={{width: '100%', border: '1px solid #999999'}}
                                value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages['ALL'])}</option>
                            <option value={true}>{intl.formatMessage(commonMessages['YES'])}</option>
                            <option value={false}>{intl.formatMessage(commonMessages['NO'])}</option>
                        </select>
                    ),
                    Cell: e => <div>{intl.formatMessage(commonMessages[e.value ? 'YES' : 'NO'])}</div>
                },
                {
                    id: 'IMMOBILIZED_VEHICLE',
                    accessor: 'immobilizedVehicle',
                    message: historyMessages.TABLE_IMMOBILIZED_VEHICLE,
                    Filter: ({filter, onChange}) => (
                        <select onChange={event => onChange(event.target.value)}
                                style={{width: '100%', border: '1px solid #999999'}}
                                value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            <option value={immobilizedVehicle[0]}>{intl.formatMessage(immobilizedVehicleMessages.YES)}</option>
                            <option value={immobilizedVehicle[1]}>{intl.formatMessage(immobilizedVehicleMessages.NO)}</option>
                        </select>
                    ),
                    Cell: e =>
                        <div>{immobilizedVehicleMessages[e.value] ? intl.formatMessage(immobilizedVehicleMessages[e.value]) : e.value}</div>
                },
                {
                    id: 'CREATED_BY',
                    accessor: 'creatorIpn',
                    message: historyMessages.TABLE_CREATED_BY,
                },
                {
                    id: 'ORDER_CREATION_TIME',
                    accessor: 'created',
                    message: historyMessages.TABLE_ORDER_CREATION_TIME,
                    Filter: ({filter, onChange}) => {
                        let value = filter && filter.value;
                        if (typeof value === 'string') {
                            value = moment(value).toDate();
                        }
                        return <DatePickerTableComponent
                            value={value || undefined}
                            onChange={onChange}
                            filter={filter}/>;
                    },
                    Cell: e => <FormattedDate value={new Date(e.value)}/>,
                },
                {
                    id: 'CLIENT_ID',
                    accessor: 'clientId',
                    message: historyMessages.TABLE_CLIENT_ID,
                    Cell: e => e.value && String(e.value).padStart(6, "0")
                },

                {
                    id: 'REG_DIR',
                    accessor: 'region',
                    message: historyMessages.TABLE_REG_DIR,
                },
                {
                    id: 'COUNTRY_CODE_3',
                    accessor: 'countryCode3',
                    message: historyMessages.TABLE_COUNTRY_CODE_3,
                },
                {
                    id: 'DEALER_NUMBER',
                    accessor: 'dealerNumber',
                    message: historyMessages.TABLE_DEALER_NUMBER,
                    Cell: e => e.value && String(e.value).padStart(8, "0")
                },
                {
                    id: 'PR',
                    accessor: 'pr',
                    message: historyMessages.TABLE_PR,
                },
                {
                    id: 'PAGE1',
                    accessor: 'pagePref',
                    message: historyMessages.TABLE_PAGE1,
                },
                {
                    id: 'PAGE2',
                    accessor: 'pagePost',
                    message: historyMessages.TABLE_PAGE2,
                },
                {
                    id: 'PART_DESCRIPTION',
                    accessor: 'partDesc',
                    message: historyMessages.TABLE_PART_DESCRIPTION,
                },
                {
                    id: 'MANAGEMENT_GROUP',
                    accessor: 'managementGroup',
                    message: historyMessages.TABLE_MANAGEMENT_GROUP,
                },
                {
                    id: 'INTERNAL_STATUS',
                    accessor: 'internalStatus',
                    message: historyMessages.TABLE_INTERNAL_STATUS,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages['ALL'])}</option>
                            {[...new Set(managedGroups.reduce((acc, cur) => internalStatuses[cur] ? acc.concat(internalStatuses[cur]) : acc, []))].map((type, index) =>
                                <option key={index} value={type}>
                                    {internalStatusMessages[type] ? intl.formatMessage(internalStatusMessages[type]) : type}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{internalStatusMessages[e.value] ? intl.formatMessage(internalStatusMessages[e.value]) : e.value}</div>
                },
                {
                    id: 'FORM_TYPE',
                    accessor: 'docType',
                    message: historyMessages.TABLE_FORM_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages['ALL'])}</option>
                            {isDealer && getDealerFormTypes(get(loggedUser, 'roles.TECHNICAL_DOCUMENTATION.dealer.formsPermission')).map((key, index) =>
                                <option key={index} value={key}>
                                    {formTypeMessages[key] ? intl.formatMessage(formTypeMessages[key]) : key}
                                </option>)
                            }
                            {isEditor && getEditorFormTypes(domain, get(loggedUser, 'roles.TECHNICAL_DOCUMENTATION.editor.groupPermission')).map((key, index) =>
                                <option key={index} value={key}>
                                    {formTypeMessages[key] ? intl.formatMessage(formTypeMessages[key]) : key}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{formTypeMessages[e.value] ? intl.formatMessage(formTypeMessages[e.value]) : e.value}</div>
                },
                {
                    id: 'PROBLEM_TYPE',
                    accessor: 'problemType',
                    message: historyMessages.TABLE_PROBLEM_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages['ALL'])}</option>
                            {[...new Set(managedGroups.reduce((acc, cur) => problemTypes[cur] ? acc.concat(problemTypes[cur]) : acc, []))].map((type, index) =>
                                <option key={index} value={type}>
                                    {problemTypeMessages[type] ? intl.formatMessage(problemTypeMessages[type]) : type}
                                </option>)
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{problemTypeMessages[e.value] ? intl.formatMessage(problemTypeMessages[e.value]) : e.value}</div>
                },
                {
                    id: 'STATUS',
                    accessor: 'status',
                    message: historyMessages.TABLE_STATUS,
                    sortable: false,
                    filterable: false,
                    Cell: e =>
                        <div>{formStatesMessages[e.value] ? intl.formatMessage(formStatesMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'SOLUTION_GROUP',
                    accessor: 'solutionGroup',
                    message: historyMessages.TABLE_SOLUTION_GROUP,
                    Cell: e =>
                        <div> {e.value && !e.value.canForwardToDealer && isDealer ? '' : get(e, 'value.name', '')}</div>
                },
                {
                    id: 'LAST_EDITOR',
                    accessor: 'lastEditor',
                    message: historyMessages.TABLE_LAST_EDITOR,
                },
                {
                    id: 'CLIENT_TYPE',
                    accessor: 'clientType',
                    message: historyMessages.TABLE_TYPE_OF_CLIENT,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {
                                Object.keys(clientTypeMessages).map((key, index) =>
                                    <option key={index} value={key}>
                                        {clientTypeMessages[key] ? intl.formatMessage(clientTypeMessages[key]) : key}
                                    </option>
                                )
                            }
                        </select>
                    ),
                    Cell: e =>
                        <div>{clientTypeMessages[e.value] ? intl.formatMessage(clientTypeMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'SRC_REQUEST',
                    accessor: 'srcRequest',
                    message: historyMessages.TABLE_SRC_TYPE,
                    Filter: ({filter, onChange}) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{width: '100%', border: '1px solid #999999'}}
                            value={filter ? filter.value : ''}>
                            <option value="">{intl.formatMessage(commonMessages.ALL)}</option>
                            {srcRequestType.map((key, index) =>
                                <option key={index} value={key}>
                                    {commonMessages[key] ? intl.formatMessage(commonMessages[key]) : key}
                                </option>)}
                        </select>
                    ),
                    Cell: e =>
                        <div>{commonMessages[e.value] ? intl.formatMessage(commonMessages[e.value]) : e.value}</div>,
                },
                {
                    id: 'SRC_CLAIM_N',
                    accessor: 'srcClaimN',
                    message: historyMessages.TABLE_SRC_N,
                }
            ],
        };

        if(isDealer) {
            this.state.columnLibrary = this.state.columnLibrary.filter(column => column.id !== 'MANAGEMENT_GROUP' && column.id !== 'COUNTRY_CODE_3');
        }
    }

    selectMultipleOption = value => {
        this.props.updateTechDocUserHistoryPreference(this.props.loggedUser.ipn,
            this.state.columnLibrary.filter(item => !value.some(value => value.id === item.id)).map(column => column.id))
    };

    render() {
        const {intl, techDocPreferences} = this.props;
        const {columnLibrary} = this.state;

        if (techDocPreferences.isLoading) {
            return <Loader/>;
        }
        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...historyMessages.TITLE}/>}/>
                <div className="d-flex justify-content-end mb-3">
                    <div className="col-xl-4 col-lg-7 col-md-9 col-sm-12">
                        <span className="font-weight-bold"><FormattedMessage {...historyMessages.VISIBLE_COLUMNS}/>{':'}</span>
                        <StyledPicky
                            value={columnLibrary.filter(item => !get(techDocPreferences, 'menuHistory', {default: []}).includes(item.id)).map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            options={columnLibrary.map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            onChange={this.selectMultipleOption}
                            open={false}
                            valueKey="id"
                            labelKey="message"
                            multiple={true}
                            includeSelectAll={true}
                            includeFilter={false}
                            selectAllText={<FormattedMessage {...commonMessages.SELECT_ALL}/>}
                            manySelectedPlaceholder={"%s " + intl.formatMessage(commonMessages.SELECTED)}
                            allSelectedPlaceholder={"%s " + intl.formatMessage(commonMessages.SELECTED)}
                            dropdownHeight={600}
                        />
                    </div>
                </div>
                <HistoryDocTable
                    columns={columnLibrary.filter(item => !get(techDocPreferences, 'menuHistory', {default: []}).includes(item.id))}/>
            </div>
        );
    }
}

HistoryTechDocPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    updateTechDocUserHistoryPreference: PropTypes.func.isRequired,
    loggedUser: PropTypes.object.isRequired,
    intl: PropTypes.any.isRequired,
    techDocPreferences: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    loggedUser: state.profile.userDetail,
    techDocPreferences: state.techDocPreferences,
});

export default checkRoles(withRouter(connect(mapStateToProps, {
    clearAlerts,
    updateTechDocUserHistoryPreference,
})(injectIntl(HistoryTechDocPage))), ['TD_DEALER', 'TD_EDITOR', 'TD_SG_EDITOR']);
